<template>
<div v-if="hasPermissionView">
  <template v-if="prestacaoConta.observacoesManifestacao">
    <v-col cols="12" v-if="!editing">
      <v-card tile class="mx-1">
        <v-card-title>
          <p>Manifestação da OSC</p> 
        </v-card-title>
        <v-card-subtitle>
          Espaço reservado para manifestação da OSC sobre o monitoramento recebido.
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Observações da OSC sobre o Monitoramento:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.observacoesManifestacao }}
              </p>
            </v-col>
            <v-list class="ml-2" v-if="prestacaoConta.arquivoManifestacao">
              <v-list-item link>
                  <v-list-item-content class="py-2">
                    <v-list-item-title>{{prestacaoConta.arquivoManifestacao.name}}</v-list-item-title>
                  </v-list-item-content>
                <v-list-item-action-text>
                  <v-btn @click="downloadItem()" class="ml-6" outlined color="primary">
                    Download <v-icon color="primary lighten-1">mdi-arrow-down-bold-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action-text>
              </v-list-item>
            </v-list>
            <v-col cols="12" class="mb-n4" v-else>
              <span class="font-weight-bold text-uppercase">Arquivo:</span>
              <p class="font-weight-light title">
                Não há arquivo registrado
              </p>
            </v-col>    
          </v-row>
        </v-card-text>        
        <v-divider></v-divider>

        <v-card-actions v-if="hasPermissionEdit" class="mx-1 py-4">
          <v-btn @click.prevent="editing = true"  color="primary text-center" small>Editar</v-btn>
          <v-btn @click="enviar()" color="info" small>Enviar para Comissão</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <ManifestacaoEditor v-else
      :prestacaoConta="prestacaoConta"
      @save="editing = false"
      @cancel="editing = false" />
  </template>
  <div v-else>
    <ManifestacaoEditor
      :prestacaoConta="prestacaoConta"
      @save="editing = false"
      @cancel="editing = false" />
  </div>
</div>
</template>

<script>
import { mapActions } from "vuex";
import ManifestacaoEditor from "./ManifestacaoEditor";
//import Confirm from "@/components/Dialog/Confirm";

export default {
  components: {
    ManifestacaoEditor,
    //Confirm,
  },
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
    papeis: {
      required: true,
    },

  },
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },

    hasPermissionEdit() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeis,
        'permission': 'PERMISSION_MANIFESTACAO_EDIT'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)
    },
    hasPermissionView() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeis,
        'permission': 'PERMISSION_MANIFESTACAO_VIEW'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)
    },

  },
  
  data () {
    return {
      editing: false,
    }
  },

  methods: {
    ...mapActions("prestacaoConta", ["proximaEtapa", "downloadArquivo"]),

    getPayload(){
       return {
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.usuario.id
      }     
    },

    enviar() {
      var payload = {
        projetoId: this.$route.params.projetoId, 
        prestacaoContaId: this.$route.params.prestacaoContaId,
        enviarPara: 'enviar-parecer'
      }

      this.proximaEtapa(payload)
    },

    downloadItem() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        'arquivoId': this.prestacaoConta.arquivoManifestacao.id
      }

      console.log(payload)
      this.downloadArquivo(payload)
    },    


  }
};
</script>

<style>
</style>